import { createAppSelector } from 'store/hooks';

export const marketplaceHabitPacksTabPanelSelector = createAppSelector(
  [
    (state) => state.habitPack.areHabitPacksLoading,
    (state) => state.setting.language
  ],
  (areHabitPacksLoading, language) => {
    return {
      areHabitPacksLoading,
      language
    };
  }
);

export const habitPackActionsSelector = createAppSelector(
  [
    (state) => state.habitPack.currentViewedPack,
    (state) => state.habitPack.installedHabitPacks
  ],
  (currentViewedPack, installedHabitPacks) => {
    return {
      currentViewedPack,
      installedHabitPacks
    };
  }
);

export const habitPackAuthenticatedActionsSelector = createAppSelector(
  [
    (state) => state.habitPack.currentViewedPack,
    (state) => state.habitPack.installedHabitPacks,
    (state) => state.user.details?.id,
    (state) => state.user.isUserAdmin
  ],
  (currentViewedPack, installedHabitPacks, userId, isUserAdmin) => {
    return {
      currentViewedPack,
      installedHabitPacks,
      userId,
      isUserAdmin
    };
  }
);

export const marketplaceLandingPageActionsSelector = createAppSelector(
  [
    (state) => state.habitPack.sharedViewedPack,
    (state) => state.focusMode.sharedFocusTemplate
  ],
  (sharedViewedPack, sharedFocusTemplate) => {
    return {
      sharedViewedPack,
      sharedFocusTemplate
    };
  }
);

export const packPreviewDrawerSelector = createAppSelector(
  [
    (state) => state.habitPack.currentViewedPack,
    (state) => state.habitPack.isCurrentHabitPackFetching,
    (state) => state.habitPack.isUserInstalledPacksFetching,
    (state) => state.habitPack.isHabitPackPdfShowed,
    (state) => state.habitPack.isUserUpsertingPack,
    (state) => state.setting.platform,
    (state) => state.inquiry.is_inquiry_modal_shown,
    (state) => state.focusMode.isUserInstalledFocusTemplatesFetching,
    (state) => state.focusMode.currentViewedFocusTemplate
  ],
  (
    currentViewedPack,
    isCurrentHabitPackFetching,
    isUserInstalledPacksFetching,
    isHabitPackPdfShowed,
    isUserUpsertingPack,
    platform,
    isInquiryModalShown,
    isUserInstalledFocusTemplatesFetching,
    currentViewedFocusTemplate
  ) => {
    return {
      currentViewedPack,
      isCurrentHabitPackFetching,
      isUserInstalledPacksFetching,
      isHabitPackPdfShowed,
      isUserUpsertingPack,
      platform,
      isInquiryModalShown,
      isUserInstalledFocusTemplatesFetching,
      currentViewedFocusTemplate
    };
  }
);

export const habitPackActionButtonSelector = createAppSelector(
  [
    (state) => state.habitPack.currentViewedPack,
    (state) => state.habitPack.installingPack,
    (state) => state.habitPack.uninstallingPack,
    (state) => state.focusMode.currentViewedFocusTemplate,
    (state) => state.focusMode.isFocusTemplateInstalling,
    (state) => state.focusMode.isFocusTemplateUninstalling,
    (state) => state.user.focus_modes,
    (state) => state.setting.language,
    (state) => state.setting.isUserSettingsModified,
    (state) => state.setting.areSettingsValid
  ],
  (
    currentViewedPack,
    installingPack,
    uninstallingPack,
    currentViewedFocusTemplate,
    isFocusTemplateInstalling,
    isFocusTemplateUninstalling,
    focus_modes,
    language,
    isUserSettingsModified,
    areSettingsValid
  ) => {
    return {
      currentViewedPack,
      installingPack,
      uninstallingPack,
      currentViewedFocusTemplate,
      isFocusTemplateInstalling,
      isFocusTemplateUninstalling,
      focus_modes,
      language,
      isUserSettingsModified,
      areSettingsValid
    };
  }
);

export const packDetailsSelector = createAppSelector(
  [
    (state) => state.habitPack.currentViewedPack,
    (state) => state.habitPack.installedHabitPacks,
    (state) => state.inquiry.is_inquiry_modal_shown,
    (state) => state.setting.platform
  ],
  (currentViewedPack, installedHabitPacks, isInquiryModalShown, platform) => {
    return {
      currentViewedPack,
      installedHabitPacks,
      isInquiryModalShown,
      platform
    };
  }
);

export const habitPackActivityListSelector = createAppSelector(
  [
    (state) => state.setting.areSettingsValid,
    (state) => state.setting.currentSettings.morning_activities,
    (state) => state.setting.currentSettings.evening_activities,
    (state) => state.setting.currentSettings.break_activities,
    (state) => state.setting.currentSettings.standalone_activities,
    (state) => state.setting.previousSettings.morning_activities,
    (state) => state.setting.previousSettings.evening_activities,
    (state) => state.setting.previousSettings.break_activities,
    (state) => state.setting.previousSettings.standalone_activities
  ],
  (
    areSettingsValid,
    currentMorning,
    currentEvening,
    currentBreak,
    currentStandalone,
    previousMorning,
    previousEvening,
    previousBreak,
    previousStandalone
  ) => {
    return {
      areSettingsValid,
      currentMorning,
      currentEvening,
      currentBreak,
      currentStandalone,
      previousMorning,
      previousEvening,
      previousBreak,
      previousStandalone
    };
  }
);

export const listOfHabitPackSelector = createAppSelector(
  [(state) => state.habitPack.marketplaceApprovedPacks],
  (marketplaceApprovedPacks) => {
    return marketplaceApprovedPacks;
  }
);

export const packLandingPageSelector = createAppSelector(
  [
    (state) => state.habitPack.isSharedHabitPackFetching,
    (state) => state.habitPack.sharedViewedPack,
    (state) => state.habitPack.installedHabitPacks,
    (state) => state.setting.isTokenAddedToInterceptor
  ],
  (
    isSharedHabitPackFetching,
    sharedViewedPack,
    installedHabitPacks,
    isTokenAddedToInterceptor
  ) => {
    return {
      isSharedHabitPackFetching,
      sharedViewedPack,
      installedHabitPacks,
      isTokenAddedToInterceptor
    };
  }
);

export const packListsSelector = createAppSelector(
  [
    (state) => state.habitPack.areHabitPacksLoading,
    (state) => state.habitPack.featuredHabitPacks,
    (state) => state.habitPack.installedHabitPacks
  ],
  (areHabitPacksLoading, featuredHabitPacks, installedHabitPacks) => {
    return {
      areHabitPacksLoading,
      featuredHabitPacks,
      installedHabitPacks
    };
  }
);
